// Hard-Block für kritische Pfade: Krypto, Rechnungsnummern, Audit-Log, Backup
import React from 'react';
import { logError } from './errorLog';

interface Props {
  guardName: string;
  children: React.ReactNode;
}

interface State {
  hasError: boolean;
  errorMessage: string;
}

export class CriticalPathGuard extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, errorMessage: '' };
  }

  static getDerivedStateFromError(error: unknown): State {
    return {
      hasError: true,
      errorMessage: error instanceof Error ? error.message : String(error),
    };
  }

  override componentDidCatch(error: unknown, info: React.ErrorInfo): void {
    void logError({
      level: 'critical',
      location: `CriticalPath:${this.props.guardName}`,
      message: error instanceof Error ? error.message : String(error),
      stack: info.componentStack ?? undefined,
    });
  }

  override render(): React.ReactNode {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className="rounded-xl border-2 border-red-400 bg-red-50 p-6 space-y-3">
        <div className="flex items-center gap-2">
          <span className="text-red-600 font-bold text-lg">🔒</span>
          <p className="text-sm font-semibold text-red-900">
            Kritischer Fehler: {this.props.guardName}
          </p>
        </div>
        <p className="text-xs text-red-800 font-mono bg-red-100 rounded p-2 break-all">
          {this.state.errorMessage}
        </p>
        <p className="text-xs text-red-700 font-medium">
          Dieser Bereich ist gesperrt. Bitte die Seite neu laden und den Fehler melden.
          <br />
          Keine Aktionen ohne Bestätigung durch Dr. Karrer vornehmen.
        </p>
      </div>
    );
  }
}
